import moment from "moment";
import { useEffect, useState } from "react";
import quizData from "../../data/home.json";
import { useLocation, useNavigate } from "react-router-dom";
import articleData from "../../data/financeFacts.json";
import FactsSection from "../../components/FactsSection";
import AdComponent from "../../components/AdComponent";
import { Link } from "react-router-dom";

const QuizResult = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const results = location.state;
    const article = articleData?.PAGE6 || {};
    if(!results){
        navigate('/');
    }
    
    useEffect(() => {
        const now = new Date();
        const currentTime = now.toTimeString().slice(0, 8);
        const filtered = quizData.filter(
            (c) => {
                return c.status === "live";
            }
        );
        setCategories(filtered);
    }, []);
    return (
        <>
            <section className="play-score-section pb">
                <div className="container"> 
                    <div className="score-header">
                        <h4>{results?.category?.name}</h4>
                        <p>Play and Win <span className="coins">{results?.category?.winner_coins}&nbsp;  
                            <span className="coinss">
                                <img src="/assets/images/dollar.png" alt="coin" />
                            </span>
                            </span>
                        </p>
                    </div> 
                    <div className="score-card">
                        <div className="score-card-inner">
                            <div className="trophy">
                                <img src="/assets/images/trophy.gif" alt="trophy" />
                            </div>
                            <p className="time-over">Time is over! Well Played</p>
                            <h2>Your score is: <span className="score">{results?.score}</span></h2>
                            <p className="winner-info">
                                Winner announcement will be @ <strong>{results?.category?.announcement_time}</strong> 
                                Based on your current score, you can win <span className="coins">{results?.category?.winner_coins}&nbsp;
                                <span className="coinss">
                                    <img src="/assets/images/dollar.png" alt="coin" />
                                </span>
                                </span> 
                            </p>  
                        </div>  
                        <div className="score-stats">
                            <div className="stat-box">
                                <h3>1</h3>
                                <p>Current Rank</p>
                            </div>
                            <div className="stat-box">
                                <h3>{results?.total_questions}</h3>
                                <p>Total Questions</p>
                            </div>
                            <div className="stat-box">
                                <h3>{results?.correct}</h3>
                                <p>Correct Answer</p>
                            </div>
                            <div className="stat-box">
                                <h3>{results?.wrong}</h3>
                                <p>Wrong Answer</p>
                            </div>
                        </div> 
                    </div> 
                </div>
            </section> 

            <section className="quizz-btn-section quizz-play-wrp pb"> 
                <div className="container">
                    <div className="quizz-btn-wrap d-flex align-items-center gap-3">
                        <Link to={"/"} className="signin-btn btn-join btn">Play Quiz</Link>
                        <Link to={"/join-contest/" + results?.category?.id} className="signin-btn btn-guest btn">Play Again</Link> 
                    </div> 
                </div>
            </section>
            <AdComponent />
            <section className="game-tabs-section pt pb">
                <div className="container">   
                    <h2>Play More Quizzes </h2>
                    <div className="game-card-wrp d-flex">
                        {categories.map((category, index) => (
                            <div className="game-card" data-category-id={category.id} key={index}>
                                <div className="game-card-top">
                                    <div className="game-icon">
                                        <img src={category.category_image} alt={category.topic_name} />
                                    </div>
                                    <div className="game-info">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <span className="category">{category.topic_name.toUpperCase()}</span>
                                            <div className="game-status">
                                                <span className="loader"></span>
                                                <span className="live-text">
                                                    {category.status.toUpperCase()}
                                                </span>
                                            </div>
                                        </div>
                                        <h3>Play and Win {Number(category.winner_coins).toLocaleString()}
                                            <span className="coin">
                                                <img src="/assets/images/dollar.png" alt="coin" />
                                            </span>
                                        </h3>
                                        <p className="subtitle">Winner announcement @ {moment(category.announcement_time).format("MMM D, YYYY h:mm A")}</p>
                                    </div>
                                </div>
                                <div className="game-card-bottom">
                                    <p className="entry">Entry : <b>{category.entry_fee}</b> <span className="coin"> <img src="/assets/images/dollar.png" alt="coin" /> </span>
                                        <b>{category.total_participants}</b> Users Playing</p>
                                    <Link to={"/join-contest/" + category.id} className="play-btn btn">PLAY</Link>
                                </div>
                            </div>
                        ))}
                    </div>   
                </div>
            </section>
            <section className="facts-section">
                <div className="container">
                    <div className="finance-fact">
                        <h2 className="fw-bold mb-4">{article?.title}</h2>
                    </div>
                    {
                        article?.content?.map((item, index) => (
                            <FactsSection key={index} item={item} />
                        ))
                    }
                    <div className="article-card">
                        <h2 className="article-card-title">{article?.action?.title}</h2>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title1}</strong> {article?.action?.desc1}
                        </p>
                        
                        <p className="article-card-desc">
                            <strong  className="desc-color">{article?.action?.title2}</strong> {article?.action?.desc2}
                        </p>
                        
                        <p className="article-card-desc">
                            {
                                article?.action?.list.map((list, index) => (
                                    <>{list}<br /></>
                                ))
                            }
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default QuizResult;